import React, { Component } from 'react'
import { observer } from 'mobx-react'
import propTypes from 'prop-types'

import './ProgressBarIndicator.sass'

class ProgressBarIndicator extends Component {
  static propTypes = {
    target: propTypes.number,
    delivered: propTypes.number,
    percent: propTypes.number,
    sideValue: propTypes.number,
    value: propTypes.oneOfType([propTypes.number, propTypes.string]),
    label: propTypes.string,
    theme: propTypes.oneOf(['red', 'green', 'blue'])
  }

  static defaultProps = {
    theme: 'blue'
  }

  calculateProgress = () => {
    const { target, delivered } = this.props
    let percent = this.props.percent || 0

    if (delivered && target) {
      percent = (delivered / target) * 100
    } else if (delivered && !target) {
      percent = 100
    }
    if (percent < 0) percent = 0

    return {
      width: percent + '%'
    }
  }

  renderSideValue = () => {
    if (!this.props.sideValue) return null
    return (
      <span className='progress-bar-indicator__info__value'>
        {this.props.sideValue}
      </span>
    )
  }

  renderValue = () => {
    const { target, delivered, value } = this.props

    if (delivered || delivered === 0) {
      if (target) {
        return `${delivered} / ${target}`
      } else {
        return `${delivered} / -`
      }
    }

    return value
  }

  render () {
    /* eslint-disable react/forbid-dom-props */
    return (
      <div className='progress-bar-indicator'>
        <div className='progress-bar-indicator__info'>
          <span className='progress-bar-indicator__info__label'>
            {this.props.label}
          </span>
          {this.renderSideValue()}
          <span className='progress-bar-indicator__info__value right'>
            {this.renderValue()}
          </span>
        </div>
        <div className='progress-bar-indicator__bar'>
          <div
            style={this.calculateProgress()}
            className='progress-bar-indicator__bar__size'
          >
            <div
              className={
                'progress-bar-indicator__bar__value--' +
                (this.props.theme || 'blue')
              }
            />
          </div>
        </div>
      </div>
    )
    /* eslint-enable react/forbid-dom-props */
  }
}

export default observer(ProgressBarIndicator)
